import React from 'react';
import styled from "styled-components";
import {Link} from "react-router-dom";

const ListItem = ({id, title, year, url, isLocation, publishedIn}) => {
    return (
        <StyledComponent className={'list-item'}>
            <Link key={id} to={url}/>
            <div className="list-item__wrap">
                <div className="content">
                    <div className="content__left">
                        <h6><strong>Name: </strong>{title}</h6>
                        {isLocation && <h6><strong>Location: </strong>{isLocation}</h6>}
                        {publishedIn && <h6><strong>Published In: </strong>{publishedIn}</h6>}
                    </div>
                    <div className="content__right">
                        <p>{year}</p>
                    </div>
                </div>
            </div>

        </StyledComponent>
    );
};

const StyledComponent = styled.div`
    position: relative;

    a {
        position: absolute;
        content: '';
        inset: 0;

    }

    .list-item {
        &__wrap {
            width: 100%;

            .content {
                display: flex;
                justify-content: space-between;
                align-items: start;

                h6 {
                    font-size: 12px;
                    line-height: 24px;
                }

                &__right {
                    p {
                        font-size: 14px;
                        color: rgba(0, 0, 0, 0.5);
                        line-height: 16px;
                    }
                }
            }
        }
    }
`;

export default React.memo(ListItem);
